<template>
  <div class="mul-ring-map wh-flex-center">
    <div class="ring-warp">
      <ring-item
        v-for="(item, index) in legendList"
        :key="index"
        class="ring"
        :percentage="item.percentage"
        :color="item.color"
      />
      <div class="per-num-list">
        <div v-for="(item, index) in legendList" :key="index" class="per-num-item">
          {{ item.percentage || 0 }}%
        </div>
      </div>
      <ring-center class="map-center" :num="ringNum" :txt="'总能耗'" :size="90" />
    </div>
    <div class="legend-warp">
      <div v-for="(item, index) in legendList" :key="index" class="legend-item">
        <span class="legend-name" :style="{color: item.color||'#fff'}">{{ item.name }}</span>
        <span class="legend-color" :style="{'background-color': item.color||'#fff'}" />
        <span class="legend-num">{{ item.num }}</span>
        <span class="legend-unit" :style="{color: item.color||'#fff'}">{{ item.unit }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import RingItem from './RingItem'
import RingCenter from '@/views/Home/components/RingCenter'
import { currency } from '@/utils/filters'
export default {
  name: 'MulRing',
  components: { RingCenter, RingItem },
  props: {
    energyConsumptionData: {
      type: Array,
      default: () => ({})
    }
  },
  data() {
    return {
      legendList: [
        {
          name: '电力',
          num: 0,
          unit: 'kW·h',
          color: '#eb6060'
        },
        {
          name: '天然气',
          num: 0,
          unit: 'm³',
          color: '#35e8ce'
        },
        {
          name: '煤炭',
          num: 0,
          unit: 'tec',
          color: '#ffcb3a'
        },
        {
          name: '其他',
          num: 0,
          unit: 'tec',
          color: '#2085e4'
        }
      ],
      ringNum: 0
    }
  },
  watch: {
    energyConsumptionData: {
      handler(newV, oldV) {
        const total = newV.reduce((total, cur) => {
          return total + Number.parseFloat(cur.transform_num || 0)
        }, 0)
        this.legendList = this.legendList.map((item, index) => {
          return {
            ...item,
            num: newV[index].num || 0,
            transform_num: newV[index].transform_num,
            percentage: total === 0 ? 0 : parseFloat((newV[index].transform_num * 100 / total).toFixed(2)),
            per: total === 0 ? `0%` : `${(newV[index].transform_num * 100 / total).toFixed(2)}%`
          }
        })
        this.ringNum = currency(this.legendList.reduce((total, cur) => Number.parseFloat(total || 0) + Number.parseFloat(cur.transform_num || 0), 0), '')
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
  .mul-ring-map{
    width: 100%;
    height: 100%;
    padding: 20px 20px 0 0;
  }
  .ring-warp{
    width: 200px;
    height: 200px;
    position: relative;
    .per-num-list{
      text-align: right;
      font-size: 12px;
      line-height: 1;
      color: rgba(221, 221, 221, 0.8);
      transform: scale(0.8);
      position: absolute;
      top: 10px;
      left: 56px;
    }
    .map-center{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      /deep/ .total-num{
        font-size: 18px!important;
        font-weight: 600;
      }
      /deep/ .total-txt{
        font-size: 18px!important;
      }
    }
  }
  .ring{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    &:nth-child(4){
      width: 107px;
      height: 107px;
      z-index: 4;
    }
    &:nth-child(3){
      width: 127px;
      height: 127px;
      z-index: 3;
    }
    &:nth-child(2){
      width: 147px;
      height: 147px;
      z-index: 2;
    }
    &:nth-child(1){
      width: 167px;
      height: 167px;
      z-index: 1;
    }
  }
  .legend-warp{
    .legend-item{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      line-height: 1;
      margin: 14px 0;
      .legend-name{
        width: 60px;
        text-align: right;
      }
      .legend-color{
        width: 14px;
        height: 14px;
        border-radius: 50%;
        margin: 0 4px 0 16px;
        background-color: #fff;
      }
      .legend-num{
        width: 80px;
        text-align: center;
        color: #fff!important;
      }
      .legend-unit{
        width: 40px;
        text-align: center;
      }
    }
  }
</style>
